/* ============================================================
   Pure Vitamins UK - Klaviyo teaser as a left-edge side tab

   22 Oct 2026 (third pass). Read before editing.

   HISTORY
   1. The teaser (the "GET 20% OFF" bar Klaviyo shows after a visitor
      closes the popup) was hidden with display:none. That broke every
      popup close on phones: Klaviyo never finished closing, an invisible
      full-screen layer stayed over the page and scrolling was locked.
   2. visibility:hidden did not work: Klaviyo's inner elements set
      visibility:visible on themselves, so the bar showed full width over
      the mobile bottom menu.
   3. Restyled into a left-edge tab, but with Klaviyo's teaser animation
      switched off. Klaviyo waits for that animation before reopening the
      form, so tapping the tab did nothing.
   4. NOW: the tab keeps Klaviyo's animation untouched, and a tap on the
      tab calls Klaviyo's own openForm command for that form directly,
      so it no longer depends on Klaviyo's internal teaser logic.

   LESSON: never switch off display or animation on Klaviyo elements.
   Klaviyo sequences its open and close on those, and breaking them
   freezes or kills the popup. Restyle position and size only.

   Layout: the teaser is a 140x40 box rotated -90deg about its top-left
   corner, leaving it 40px wide and 140px tall on the left edge,
   mid-screen, reading bottom to top. The Inbox chat button owns the
   right side and the bottom menu stays clear.

   SAFETY NET: if the body is still scroll-locked by Klaviyo but no
   Klaviyo dialog is visible for over 1.2s, the lock and any transparent
   leftover layer are released.

   window.PV_KLFORMS reports what was done.
   ============================================================ */

(function () {
  'use strict';

  var state = { released: 0, opened: 0, mode: 'side-tab-left' };
  window.PV_KLFORMS = state;

  var CSS = [
    '[class*="kl-teaser-"]{',
    '  top:calc(50% + 70px)!important;bottom:auto!important;',
    '  left:0!important;right:auto!important;margin:0!important;',
    '  width:140px!important;height:40px!important;',
    '  transform:rotate(-90deg)!important;transform-origin:top left!important;',
    '  filter:drop-shadow(rgba(0,0,0,.18) 0 2px 8px)!important;',
    '  visibility:visible!important;pointer-events:auto!important;',
    '}',
    '[class*="kl-teaser-"] [role="button"]{',
    '  min-height:40px!important;height:40px!important;padding:0 10px!important;',
    '  border-radius:0 0 12px 12px!important;cursor:pointer;',
    '}',
    '[class*="kl-teaser-"] p,[class*="kl-teaser-"] span,[class*="kl-teaser-"] strong{',
    '  font-size:14px!important;line-height:1!important;',
    '  letter-spacing:.04em!important;white-space:nowrap!important;',
    '}'
  ].join('');

  function injectCss() {
    if (document.getElementById('pv-kl-teaser-tab')) return;
    var s = document.createElement('style');
    s.id = 'pv-kl-teaser-tab';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }
  injectCss();

  /* Tap on the tab: open that teaser's form through Klaviyo's public
     command queue. Capture phase, so it runs before Klaviyo's handler. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[class*="kl-teaser-"]') : null;
    if (!t) return;
    var m = String(t.className).match(/kl-teaser-([A-Za-z0-9]+)/);
    if (!m) return;
    e.preventDefault();
    e.stopPropagation();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', m[1]]);
    state.opened++;
  }, true);

  /* Undo inline hiding left by older versions of this file, if cached. */
  function unhideOld() {
    var t = document.querySelectorAll('[class*="kl-teaser-"][data-pv-hidden]');
    for (var i = 0; i < t.length; i++) {
      t[i].style.removeProperty('display');
      t[i].style.removeProperty('visibility');
      t[i].style.removeProperty('pointer-events');
      t[i].removeAttribute('data-pv-hidden');
    }
  }

  function isVisible(el) {
    var s = window.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' &&
      parseFloat(s.opacity) > 0.05 && el.offsetWidth > 0;
  }

  var lockSince = 0;
  function releaseStuckLock() {
    var body = document.body;
    if (!body || !body.classList.contains('klaviyo-prevent-body-scrolling')) {
      lockSince = 0;
      return;
    }
    var dialogs = document.querySelectorAll('[role="dialog"][class*="kl-private"], [class*="kl-private"] [role="dialog"]');
    for (var i = 0; i < dialogs.length; i++) {
      if (isVisible(dialogs[i])) { lockSince = 0; return; }
    }
    if (!lockSince) { lockSince = Date.now(); return; }
    if (Date.now() - lockSince < 1200) return;

    body.classList.remove('klaviyo-prevent-body-scrolling');
    for (var j = 0; j < dialogs.length; j++) {
      dialogs[j].style.setProperty('pointer-events', 'none', 'important');
    }
    lockSince = 0;
    state.released++;
  }

  setInterval(function () { injectCss(); unhideOld(); releaseStuckLock(); }, 500);
})();
